import React, { useState } from "react";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "../css/ExportDateRangeModal.css";

const ExportDateRangeModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Get today's date as the maximum allowed date (no future dates)
  const maxDate = dayjs();

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (fromDate && toDate) {
      onConfirm(fromDate, toDate);
    }
  };

  const handleClose = () => {
    setFromDate(null);
    setToDate(null);
    onClose();
  };

  return (
    <div className="export-date-range-modal-overlay">
      <div className="export-date-range-modal-content">
        <button className="export-date-range-modal-close" onClick={handleClose}>
          ×
        </button>
        <div className="export-date-range-modal-message">
          Data will be exported and sent over email.
        </div>
        <div className="export-date-range-modal-date-pickers">
          <div className="export-date-range-modal-date-field">
            <label className="export-date-range-modal-date-label">From Date</label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDatePicker
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                format="YYYY-MM-DD"
                maxDate={maxDate}
                slotProps={{
                  textField: {
                    placeholder: "YYYY-MM-DD",
                    className: "export-date-range-modal-date-input",
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="export-date-range-modal-date-field">
            <label className="export-date-range-modal-date-label">To Date</label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDatePicker
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                format="YYYY-MM-DD"
                minDate={fromDate}
                maxDate={maxDate}
                slotProps={{
                  textField: {
                    placeholder: "YYYY-MM-DD",
                    className: "export-date-range-modal-date-input",
                  },
                }}
              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="export-date-range-modal-question">
          Do you want to continue?
        </div>
        <div className="export-date-range-modal-buttons">
          <button
            className="export-date-range-modal-yes-button"
            onClick={handleConfirm}
            disabled={isLoading || !fromDate || !toDate}
          >
            {isLoading ? "Loading..." : "Yes"}
          </button>
          <button
            className="export-date-range-modal-cancel-button"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportDateRangeModal;
